import React, { Component } from 'react'
import PropTypes from 'prop-types'

class RiderRemoveShareModal extends Component {
  render() {
    return (
      <div className="modal modal-sidebar">
        <label>Are you sure you want to remove {this.props.member}?</label>

        <button className="btn-danger" onClick={() => {
          this.props.removeRiderShare()
          this.props.setModal(false)
        }}>Remove</button>

        <button className="btn-back" onClick={() => this.props.setModal(false)}>Go back</button>
      </div>
    )
  }
}

RiderRemoveShareModal.propTypes = {
  member: PropTypes.string,
  removeRiderShare: PropTypes.func,
  setModal: PropTypes.func
}

RiderRemoveShareModal.defaultProps = {
  member: '',
  removeRiderShare: function() {},
  setModal: function() {}
}

export default RiderRemoveShareModal



// WEBPACK FOOTER //
// ./src/components/modals/rider-remove-share-modal.js